// extracted by mini-css-extract-plugin
module.exports = {"clickable":"Input_clickable__3zhJX"};